<template src="./template.html"></template>

<script>
import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';
import BaseReportTable from "@/components/BaseReportTable";
import Moment from "moment";
import notification from "@/plugins/vue-notification-config";
import Paginate from 'vuejs-paginate';
import {getQueryPage} from "@/utils/helperFunction";
import BaseCrudRange from "@/components/BaseCrudRange";


export default {
  data() {
    return {
      pageCount: 0,
      tableData: [],
      departments: [],
      permission: null,

      filter: {
        isScreenshot: false,
        userId: null,
        date: new Date(),
        departmentId: null
      },
      params: {
        page: 0,
        perPage: 10,
      },
      usersList: []
    }
  },
  components: {BaseReportTable, vSelect, Datepicker, Paginate, BaseCrudRange},
  computed: {
    disableDatePicker() {
      let today = Moment().format('DD-MM-YY');
      let date = Moment(this.filter.date).format('DD-MM-YY');
      return today === date;
    },
    permissions() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.permission = this.$store.state.permissionList.find(item => item.codeName === 'REPORT_PERSON_FULL_WEEKLY')
      if (!this.permission) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.filter.userId = this.$store.state.userProfile.id;
      }
      return this.permission;
    }
  },
  methods: {
    async getDepartments() {
      try {
        const {data: {data}} = await this.$api.get('departments')
        this.departments = data
      } catch (e) {
        notification.error(e)
      }
    },
    async onInputPaginate(page) {
      this.params.page = page - 1
      this.$store.commit('$SHOW_LOADING')
      this.$router.replace({query: {page: page - 1}})
      await this.GetTableData()
      this.$store.commit('$CLEAR_LOADING')
    },
    minuteToString(minute) {
      if (!minute) return 0
      let str = ''
      let h = parseInt(minute / 60)
      let m = minute % 60
      if (h) str += h.toString() + 'h'
      if (m) str += (' ' + m + 'm')
      return str
    },
    parseData(item, index) {
      if (item.signIn) item.signIn = this.$options.filters.filterDateHour(item.signIn)
      if (item.signOut) item.signOut = this.$options.filters.filterDateHour(item.signOut)
      item.index = this.params.page * this.params.perPage + index + 1
      item.dailyTaskSpendTime = this.minuteToString(item.dailyTaskSpendTime)
      return item
    },
    async GetTableData() {
      try {
        let params = {...this.params, ...this.filter}
        params.date = Moment(params.date).format('YYYY-MM-DD')
        const {data: {data: {dtoList, resultCount, totalCount}}} = await this.$api('report/daily/employee/activitis', {
          params
        })
        this.tableData = dtoList.map(this.parseData)
        this.pageCount = Math.ceil(totalCount / params.perPage)
      } catch (e) {
        notification.error()
      }
    },
    async getUsers() {
      let params = {
        isGroupMembers: this.isTeamLeader
      }
      try {
        await this.$api.get('employees', {params})
            .then((res => {
              this.usersList = res.data.data
            }))
      } catch (e) {
        notification.error()
      }
    },

    async changedFilter() {
      this.$store.commit('$SHOW_LOADING')
      if (this.params.page !== 0) {
        this.params.page = 0
        this.$router.replace({query: {page: '0'}})
      }
      await this.GetTableData()
      this.$store.commit('$CLEAR_LOADING')
    },
    getUsersOptionLabel(item) {
      return `${item.fullName}`
    },
    nextDay() {
      let date = this.filter.date
      if (!date) date = new Date()
      this.filter.date = Moment(date).add(1, 'day')._d
      this.changedFilter()
    },
    prevDay() {
      let date = this.filter.date
      if (!date) date = new Date()
      this.filter.date = Moment(date).subtract(1, 'day')._d
      this.changedFilter()
    }
  },
  async mounted() {
    this.params.page = getQueryPage(this.$route.query)
    this.$store.commit('$SHOW_LOADING')
    await this.GetTableData()
    this.$store.commit('$CLEAR_LOADING')
    await Promise.all([this.getUsers()])
  },


}
</script>
